import Vue from 'vue'

/**
 * 获取离线code
 * @param {*} params
 */
export const getApplyCode = params => {
  return Vue.fetch.post('/license/getApplyCode', params)
}
/**
 *申请在线
 * @param {*} params
 */
export const sumbitApplyOnline = params => {
  return Vue.fetch.post('/license/applyOnline', params)
}

/**
 * 填写用户信息
 * @param {*} params
 */
export const saveCusInfo = params => {
  return Vue.fetch.post('/license/saveApplyKey', params)
}

/**
 * 获取客户信息
 * @param {*} params
 */
export const getLicenseInfo = params => {
  return Vue.fetch.post('/license/infos', params)
}

/**
 * 当前许可信息
 * @param {*} params
 */
export const getNewestApplyOnlineInfo = params => {
  return Vue.fetch.post('/license/queryNewestApplyOnlineInfo', params)
}



// WEBPACK FOOTER //
// ./src/services/license.js